import moment from "moment";

export default function getWeekLabel(value: number) {
  const time1 = moment.utc(value);
  const time2 = moment.utc(value + +1000 * 60 * 60 * 24 * 7 - 1);

  const month1 = time1.format("MMM");
  const month2 = time2.format("MMM");

  if (month1 !== month2) {
    return time1.format("MMM D") + " - " + time2.format("MMM D");
  }
  return time1.format("MMM D") + "-" + time2.format("D");
}
